// extracted by mini-css-extract-plugin
export default {"icon":"ConstructionTypeIcon_icon__T8KDU"};